import React from "react";
import { Redirect, Route } from "react-router-dom";

function ProtectedRoute({ component: Component, redirectTo = "/se-connecter", forceLogout = false, ...restOfProps }) {
  const isAuthenticated = localStorage.getItem("token");
  
  // Handle forced re-authentication
  if (forceLogout && isAuthenticated) {
    const searchParams = new URLSearchParams(window.location.search);
    const hasJustAuthenticated = searchParams.get("authenticated") === "true";
    
    if (!hasJustAuthenticated) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return (
        <Redirect
          to={{
            pathname: redirectTo,
            state: { from: { pathname: restOfProps.path || window.location.pathname } }
          }}
        />
      );
    }
  }

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectTo,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}



export default ProtectedRoute;